import { useRecoilState, useResetRecoilState } from "recoil";
import { myTimesheetOpenFilterState } from "my-timesheet/states";

export const useMyTimesheetFilterOpenState = () => {
  const [state, setState] = useRecoilState(myTimesheetOpenFilterState);
  const resetState = useResetRecoilState(myTimesheetOpenFilterState);

  return {
    state,
    setState,
    resetState,
  };
};

export default useMyTimesheetFilterOpenState;
